export default {
  arrives: 'Ankunft',
  journeyDuration: 'Reisedauer',
}
